import clsx from 'clsx'

import { DragHandleFilledIcon } from '@/components/icons/DragHandleFilled'
import { Icon } from '@/components/ui'

import { FavoriteCardListItemProps } from './type'
import { FavoriteCard } from '../../FavoriteCard'

export const FavoriteCardListItem = ({
  favorite,
  sortable,
  isDepositStore,
  isMyFavorites,
  isOperationDirectionTop,
  onClickCopy,
  onClickDelete,
  onClickEdit,
}: FavoriteCardListItemProps) => {
  return (
    <li
      className={clsx(
        'tw-h-11',
        'tw-flex tw-items-center',
        'tw-pl-2',
        'tw-border-b tw-border-gray-300'
      )}
    >
      {sortable && (
        <div className={clsx('tw-flex-none', 'tw-pl-2', 'tw-touch-none')}>
          <Icon icon={DragHandleFilledIcon} size={'2xl'} color={'primary'} />
        </div>
      )}
      <div className={clsx('tw-flex-1')}>
        <FavoriteCard
          favorite={favorite}
          showActions={!sortable && isMyFavorites}
          isOperationDirectionTop={isOperationDirectionTop}
          isMyFavorite={isMyFavorites}
          isDepositStore={isDepositStore}
          disabled={sortable}
          onClickCopy={() => onClickCopy && onClickCopy(favorite)}
          onClickDelete={() => onClickDelete && onClickDelete(favorite)}
          onClickEdit={() => onClickEdit && onClickEdit(favorite)}
        />
      </div>
    </li>
  )
}
